// psImageUrls.js
//
// PehchaanSetu never stores an image URL in Mongo — filenames are
// deterministic (<code>.webp), matching the pattern the profile-pic upload
// already used. We just build the URL from the entity's slug/code and
// cache-bust with `updatedAt` so a fresh upload shows immediately instead
// of serving a stale browser-cached image.
//
// ASSUMPTION: file serving goes through `/api/downloads/<folder>/<file>`,
// matching backend/utils/buildFileResponse.js's local-driver URL shape. If
// your server exposes uploads differently (e.g. a static /uploads mount),
// change DOWNLOAD_BASE below — it's the one thing this file assumes about
// your server that isn't in the code you shared.
const DOWNLOAD_BASE = "/api/downloads";

function withCacheBust(url, updatedAt) {
  const v = updatedAt ? new Date(updatedAt).getTime() : "";
  return v ? `${url}?v=${v}` : url;
}

export function chapterBannerUrl(chapter, versionOverride) {
  if (!chapter?.slug) return null;
  return withCacheBust(`${DOWNLOAD_BASE}/pehchaansetu/channels/${chapter.slug}.webp`, versionOverride || chapter.updatedAt);
}

export function circleBannerUrl(circle, versionOverride) {
  if (!circle?.slug) return null;
  return withCacheBust(`${DOWNLOAD_BASE}/pehchaansetu/circles/${circle.slug}.webp`, versionOverride || circle.updatedAt);
}

export function profilePicUrl(userCode, updatedAt) {
  if (!userCode) return null;
  return withCacheBust(`${DOWNLOAD_BASE}/users/profilepic/${userCode}.webp`, updatedAt);
}
